import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './projectDetails.css';
import LazyLoad from 'react-lazyload';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import {WhatGPT3 } from '../../containers'

const ProjectDetails = () => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();
  const videoRefs = useRef({});
  const [playingVideos, setPlayingVideos] = useState({});

  useEffect(() => {
    const fetchProject = async () => {
      try {
        console.log('Fetching project with slug or ID:', slug);
        if (!slug) {
          throw new Error('Slug or ID is undefined');
        }

        let projectData;

        // First, try to fetch by slug
        const projectRef = collection(db, 'projects');
        const q = query(projectRef, where('slug', '==', slug));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          projectData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        } else {
          // If not found by slug, try to fetch by ID
          const docRef = doc(db, 'projects', slug);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            projectData = { id: docSnap.id, ...docSnap.data() };
          } else {
            throw new Error('No project found for this slug or ID!');
          }
        }

        console.log('Project data:', projectData);
        setProject(projectData);
      } catch (error) {
        console.error('Error fetching project:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [slug]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(error => console.error('Error playing video:', error));
            setPlayingVideos(prev => ({ ...prev, [video.id]: true }));
          } else {
            video.pause();
            setPlayingVideos(prev => ({ ...prev, [video.id]: false }));
          }
        });
      },
      { threshold: 0.5 }
    );

    Object.values(videoRefs.current).forEach(video => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videoRefs.current).forEach(video => {
        if (video) observer.unobserve(video);
      });
    };
  }, [project]);

  const handlePlayPause = (videoId) => {
    const video = videoRefs.current[videoId];
    if (video) {
      if (playingVideos[videoId]) {
        video.pause();
      } else {
        video.play().catch(error => console.error('Error playing video:', error));
      }
      setPlayingVideos(prev => ({ ...prev, [videoId]: !prev[videoId] }));
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Project Details...</p>
      </div>
    );
  }
  

  const renderContent = (content) => {
    if (typeof content === 'string') {
      return content.split(',').map(item => item.trim());
    }
    return Array.isArray(content) ? content : [content];
  };

  const getProjectLink = (relatedProject) => {
    return relatedProject.slug ? `/work/${relatedProject.slug}` : `/work/${relatedProject.id}`;
  };

  return (
    <div className='ulev_details'>
      {project.coverMedia && (
        <div className="ulev__details-cover-overlay-container" style={{ position: "relative" }}>
          <div className="single-image-section">
            {project.coverMedia.type === 'video' ? (
              <video
                ref={(el) => (videoRefs.current['cover'] = el)}
                id="cover"
                loop
                autoPlay
                muted
                playsInline
                onClick={() => handlePlayPause('cover')}
                style={{ cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover' }}
              >
                <source src={project.coverMedia.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <BlurhashImg src={project.coverMedia.url} placeholderColor="#888" />
            )}
            <div className="overlay-background"></div>
            <div className="ulev__details-title-overlay">
              <h1 className="overlay-title">{project.description || 'No Description'}</h1>
              <h2 className="overlay-subtitle">{project.title || 'No Title'}</h2>
            </div>
          </div>
        </div>
      )}

      <div className='section_pad-des'>
        <h1 className="overlay-titl" style={{}}>{project.description || 'No Description'}</h1>
      </div>


      {project.sections && project.sections.length > 0 && project.sections.map((section, index) => (
        <div key={index} className="ulev_morePD " id={`section-${index}`}>
          {section.type === 'text_pair' && (
            <div className='ulev__details-text-pair sectiona__padding'>
              {renderContent(section.content).map((text, idx) => (
                <div key={idx} className='half-text-section'>
                  <div 
                    dangerouslySetInnerHTML={{ __html: text }} 
                    className="ulev_morePD-content"
                    style={{ color: '#fff' }}
                  />
                </div>
              ))}
            </div>
          )}
          {section.type === 'text' && (
            <div className="ulev_morePD-contain sectiona__padding">
              <p className='ulev_morePD-other'></p>
              <div className='ulev_morePD-p'>
                <div 
                  dangerouslySetInnerHTML={{ __html: section.content }} 
                  className="ulev_morePD-content"
                  style={{color: "#fff"}}
                />
              </div>
            </div>
          )}
          {section.type === 'image' && section.layout !== 'double' && (
            <div className='ulev__details-images image__padding' style={{padding: "0rem 4.2rem 0rem 4.2rem"}}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <BlurhashImg src={url} placeholderColor="#888"/>
                </div>
              ))}
            </div>
          )}
          {section.type === 'image_pair' && (
            <div className='ulev__details-image-pair sectionass__padding'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className='half-image-section'>
                  <BlurhashImg src={url} placeholderColor="#888"/>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout === 'double' && (
            <div className='ulev__details-images section__padding ulev__details-images-double'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <video
                    ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
                    id={`video-${index}-${idx}`}
                    loop
                    autoPlay
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout !== 'double' && (
            <div className='ulev__details-images ' style={{padding: "4rem 4rem 4rem 4rem"}}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <video
                    ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
                    id={`video-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video_pair' && (
            <div className='ulev__details-video-pair sectiona__padding-vid'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className='half-video-section'>
                  <video
                    ref={el => videoRefs.current[`video-pair-${index}-${idx}`] = el}
                    id={`video-pair-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-pair-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      
      {project.relatedProjects && project.relatedProjects.length > 0 && (
        <div className="related-container section__padding-relat">
          <h1 className="related" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "clamp(28px, 4vw, 28px)", fontWeight: "600"}}>Related Case Studies</h1>
          <div className="related-projects-grid">
            {project.relatedProjects.map((relatedProject, index) => (
              <Link key={index} to={`/work/${relatedProject.slug}`} className="related-card">
                <div className="related-image-container">
                  <LazyLoad>
                    <img
                      src={relatedProject.coverImage}
                      alt={relatedProject.title}
                      className="related-image"
                    />
                  </LazyLoad>
                  {/* <div className="overlay">
                    <h2 className="related-title">{relatedProject.title}</h2>
                    <p className="related-subtitle">{relatedProject.description || ''}</p>
                    <p className="related-location">{relatedProject.location || ''}</p>
                  </div> */}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}  
      {/* {project.relatedProjects && project.relatedProjects.length > 0 && (
        <div className="related-container section__padding">
          <h1 className="related">Related Articles</h1>
          <div className="related-projects-grid">
            {project.relatedProjects.map((relatedProject, index) => (
              <Link key={index} to={`/work/${relatedProject.slug}`} className="related-card">
                <div className="related-image-container">
                  <LazyLoad>
                    <img
                      src={relatedProject.coverImage}
                      alt={relatedProject.title}
                      className="related-image"
                    />
                  </LazyLoad>
                  <div className="overlay">
                    <h2 className="related-title">{relatedProject.title}</h2>
                    <p className="related-subtitle">{relatedProject.description || ''}</p>
                    <p className="related-location">{relatedProject.location || ''}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}  */}
      <WhatGPT3 />
    </div>
  );
};

export default ProjectDetails;















// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
// import { db } from '../../firebase';
// import './projectDetails.css';
// import LazyLoad from 'react-lazyload';
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import {WhatGPT3 } from '../../containers'

// const ProjectDetails = () => {
//   const [project, setProject] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { slug } = useParams();
//   const videoRefs = useRef({});
//   const [playingVideos, setPlayingVideos] = useState({});

//   useEffect(() => {
//     const fetchProject = async () => {
//       try {
//         console.log('Fetching project with slug or ID:', slug);
//         if (!slug) {
//           throw new Error('Slug or ID is undefined');
//         }

//         let projectData;

//         // First, try to fetch by slug
//         const projectRef = collection(db, 'projects');
//         const q = query(projectRef, where('slug', '==', slug));
//         const querySnapshot = await getDocs(q);

//         if (!querySnapshot.empty) {
//           projectData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
//         } else {
//           // If not found by slug, try to fetch by ID
//           const docRef = doc(db, 'projects', slug);
//           const docSnap = await getDoc(docRef);

//           if (docSnap.exists()) {
//             projectData = { id: docSnap.id, ...docSnap.data() };
//           } else {
//             throw new Error('No project found for this slug or ID!');
//           }
//         }

//         console.log('Project data:', projectData);
//         setProject(projectData);
//       } catch (error) {
//         console.error('Error fetching project:', error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [slug]);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           const video = entry.target;
//           if (entry.isIntersecting) {
//             video.play().catch(error => console.error('Error playing video:', error));
//             setPlayingVideos(prev => ({ ...prev, [video.id]: true }));
//           } else {
//             video.pause();
//             setPlayingVideos(prev => ({ ...prev, [video.id]: false }));
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     Object.values(videoRefs.current).forEach(video => {
//       if (video) observer.observe(video);
//     });

//     return () => {
//       Object.values(videoRefs.current).forEach(video => {
//         if (video) observer.unobserve(video);
//       });
//     };
//   }, [project]);

//   const handlePlayPause = (videoId) => {
//     const video = videoRefs.current[videoId];
//     if (video) {
//       if (playingVideos[videoId]) {
//         video.pause();
//       } else {
//         video.play().catch(error => console.error('Error playing video:', error));
//       }
//       setPlayingVideos(prev => ({ ...prev, [videoId]: !prev[videoId] }));
//     }
//   };

//   if (loading) return <div>Loading project details...</div>;
//   if (error) return <div>Error: {error}</div>;
//   if (!project) return <div>No project found</div>;

//   const renderContent = (content) => {
//     if (typeof content === 'string') {
//       return content.split(',').map(item => item.trim());
//     }
//     return Array.isArray(content) ? content : [content];
//   };

//   const getProjectLink = (relatedProject) => {
//     return relatedProject.slug ? `/work/${relatedProject.slug}` : `/work/${relatedProject.id}`;
//   };

//   return (
//     <div className='ulev_details'>
//       <div className="ulev__details-title section__padding">
//         <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
//           <div className='ulev__details-title-big'>
//             <h1 style={{color: '#000000'}}><span>{project.title || 'No Title'}</span></h1>
//             <h2 style={{color: '#CD3333'}}>{project.subtitle || 'No Subtitle'}</h2>
//           </div>
//           {/* <div className='ulev__details-description' style={{ textAlign: 'right' }}>
//             <p style={{color: '#8a8a8a', marginBottom: "auto", fontSize: '16px'}}>{project.description || 'No Description'}</p>
//           </div> */}
//         </div>
//       </div>

//       {project.coverMedia && (
//         <div className='ulev__details-images' style={{padding: "2rem 4rem 0rem 4rem"}}>
//           <div className="single-image-section">
//             {project.coverMedia.type === 'video' ? (
//               <video
//                 ref={el => videoRefs.current['cover'] = el}
//                 id="cover"
//                 loop
//                 autoPlay
//                 muted
//                 playsInline
//                 onClick={() => handlePlayPause('cover')}
//                 style={{ cursor: 'pointer' }}
//               >
//                 <source src={project.coverMedia.url} type="video/mp4" />
//                 Your browser does not support the video tag.
//               </video>
//             ) : (
//               <BlurhashImg src={project.coverMedia.url} placeholderColor="#888"/>
//             )}
//           </div>
//         </div>
//       )}

//       {project.sections && project.sections.length > 0 && project.sections.map((section, index) => (
//         <div key={index} className="ulev_morePD " id={`section-${index}`}>
//           {section.type === 'text' && (
//             <div className="ulev_morePD-contain sectiona__padding">
//               <p className='ulev_morePD-other'></p>
//               <div className='ulev_morePD-p'>
//                 <div 
//                   dangerouslySetInnerHTML={{ __html: section.content }} 
//                   className="ulev_morePD-content"
//                   style={{color: "#fff"}}
//                 />
//               </div>
//             </div>
//           )}
//           {section.type === 'image' && section.layout !== 'double' && (
//             <div className='ulev__details-images image__padding' style={{padding: "0rem 4.2rem 0rem 4.2rem"}}>
//               {renderContent(section.content).map((url, idx) => (
//                 <div key={idx} className="single-image-section">
//                   <BlurhashImg src={url} placeholderColor="#888"/>
//                 </div>
//               ))}
//             </div>
//           )}
//           {section.type === 'image_pair' && (
//             <div className='ulev__details-image-pair sectionass__padding'>
//               {renderContent(section.content).map((url, idx) => (
//                 <div key={idx} className='half-image-section'>
//                   <BlurhashImg src={url} placeholderColor="#888"/>
//                 </div>
//               ))}
//             </div>
//           )}
//           {section.type === 'video' && section.layout === 'double' && (
//             <div className='ulev__details-images section__padding ulev__details-images-double'>
//               {renderContent(section.content).map((url, idx) => (
//                 <div key={idx} className="single-image-section">
//                   <video
//                     ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
//                     id={`video-${index}-${idx}`}
//                     loop
//                     autoPlay
//                     muted
//                     playsInline
//                     onClick={() => handlePlayPause(`video-${index}-${idx}`)}
//                     style={{ cursor: 'pointer' }}
//                   >
//                     <source src={url} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 </div>
//               ))}
//             </div>
//           )}
//           {section.type === 'video' && section.layout !== 'double' && (
//             <div className='ulev__details-images ' style={{padding: "4rem 4rem 4rem 4rem"}}>
//               {renderContent(section.content).map((url, idx) => (
//                 <div key={idx} className="single-image-section">
//                   <video
//                     ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
//                     id={`video-${index}-${idx}`}
//                     autoPlay
//                     loop
//                     muted
//                     playsInline
//                     onClick={() => handlePlayPause(`video-${index}-${idx}`)}
//                     style={{ cursor: 'pointer' }}
//                   >
//                     <source src={url} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 </div>
//               ))}
//             </div>
//           )}
//           {section.type === 'video_pair' && (
//             <div className='ulev__details-video-pair sectiona__padding-vid'>
//               {renderContent(section.content).map((url, idx) => (
//                 <div key={idx} className='half-video-section'>
//                   <video
//                     ref={el => videoRefs.current[`video-pair-${index}-${idx}`] = el}
//                     id={`video-pair-${index}-${idx}`}
//                     autoPlay
//                     loop
//                     muted
//                     playsInline
//                     onClick={() => handlePlayPause(`video-pair-${index}-${idx}`)}
//                     style={{ cursor: 'pointer' }}
//                   >
//                     <source src={url} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       ))}
      
//       {project.relatedProjects && project.relatedProjects.length > 0 && (
//         <div className="related-container section__padding">
//           <h1 className="related">More Stories</h1>
//           <div className="related-projects-grid">
//             {project.relatedProjects.map((relatedProject, index) => (
//               <Link key={index} to={`/work/${relatedProject.slug}`} className="related-card">
//                 <div className="related-image-container">
//                   <LazyLoad>
//                     <img
//                       src={relatedProject.coverImage}
//                       alt={relatedProject.title}
//                       className="related-image"
//                     />
//                   </LazyLoad>
//                   <div className="overlay">
//                     <h2 className="related-title">{relatedProject.title}</h2>
//                     <p className="related-subtitle">{relatedProject.description || ''}</p>
//                     <p className="related-location">{relatedProject.location || ''}</p>
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       )} 
//       <WhatGPT3 />
//     </div>
//   );
// };

// export default ProjectDetails;
